export { default } from './TrendingStoriesOverview';
export { default as reducer } from './TrendingStoriesOverview.slice';

import * as actions from './TrendingStoriesOverview.slice';

export { default as sagas } from './TrendingStoriesOverview.sagas';

export { actions };
